import { render, staticRenderFns } from "./EditCompanySetting.vue?vue&type=template&id=eab4c15c&"
import script from "./EditCompanySetting.vue?vue&type=script&lang=js&"
export * from "./EditCompanySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports